import { render, staticRenderFns } from "./codeEditor.vue?vue&type=template&id=12ae29a6&scoped=true"
import script from "./codeEditor.vue?vue&type=script&lang=js"
export * from "./codeEditor.vue?vue&type=script&lang=js"
import style0 from "./codeEditor.vue?vue&type=style&index=0&id=12ae29a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae29a6",
  null
  
)

export default component.exports